module.exports = __webpack_public_path__ + "images/thumb-b07e7906b9374ea045bbb33eea93727b.jpg";